import React, {memo} from 'react';
import {default as Tooltip} from '@homeaway/react-tooltip';
import PropTypes from 'prop-types';

import './property-details.less';

const combineAddress = (address) => {
    const {city, stateProvince, country} = address;
    let combined = '';
    if (city) {
        combined += `${city},`;
    }
    if (stateProvince) {
        combined += ` ${stateProvince},`;
    }
    if (country) {
        combined += ` ${country}`;
    }
    return combined;
};

const PropertyDetails = ({headline, address, rating}) => {
    return (
        <div className="property-details">
            {headline && (
                <Tooltip
                    centered
                    trigger="hover focus"
                    tooltipType="popover"
                    content={headline}
                    placement="top"
                    wrappingMethod="block"
                    interactiveContainer
                >
                    <h2
                        tabIndex={0}
                        className="property-details__headline truncate"
                        data-testid="wdio_checkout-page_property-details-headline"
                    >
                        {headline}
                    </h2>
                </Tooltip>
            )}
            {address && (
                <span
                    className="property-details__address"
                    data-testid="wdio_checkout-page_property-details-address"
                >
                    {combineAddress(address)}
                </span>
            )}
            {rating}
        </div>
    );
};

PropertyDetails.propTypes = {
    headline: PropTypes.string,
    address: PropTypes.shape({
        city: PropTypes.string,
        stateProvince: PropTypes.string,
        country: PropTypes.string,
    }),
    rating: PropTypes.object,
};

export default memo(PropertyDetails);
